import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';
import { HomeComponent } from './home/home.component';
import { FailedComponent } from './failed/failed.component';
import { LoggedOutComponent } from './logged-out/logged-out.component';
import { AppLayoutComponent } from './modules/layout/app.layout.component';
import { InvoiceDemoComponent } from './invoice-demo/invoice-demo.component';
import { tenantContextGuard } from './guards/tenant-context.guard';

const featureGuards = [MsalGuard, tenantContextGuard];

const routes: Routes = [
    {
        path: 'public/tar/:token',
        loadComponent: () => import('./modules/form-engine/presentation/public-tar-status/public-tar-status.component')
            .then(m => m.PublicTarStatusComponent)
    },
    {
        path: 'logged-out',
        component: LoggedOutComponent
    },
    {
        path: '', component: AppLayoutComponent, children: [
            { path: 'epp', loadChildren: () => import('./modules/epps/epps.module').then(m => m.EppsModule), canActivate: featureGuards },
            { path: 'notifications', loadChildren: () => import('./modules/notifications/notifications.module').then(m => m.NotificationsModule), canActivate: featureGuards },
            { path: 'inspection', loadChildren: () => import('./modules/inspection/inspection.module').then(m => m.InspectionModule), canActivate: featureGuards },
            { path: 'admin', loadChildren: () => import('./modules/administration/administration.module').then(m => m.AdministrationModule), canActivate: featureGuards },
            { path: 'powerbi', loadChildren: () => import('./modules/power-bi/power-bi.module').then(m => m.PbiembeddedModule), canActivate: featureGuards },
            { path: 'operational-control', loadChildren: () => import('./modules/operational-control/operational-control.module').then(m => m.OperationalControlModule), canActivate: featureGuards },
            { path: 'document-management', loadChildren: () => import('./modules/document-management/document-management.module').then(m => m.DocumentManagementModule), canActivate: featureGuards },
            { path: 'contractor-administration', loadChildren: () => import('./modules/contractor-administration/contractor-administration.module').then(m => m.ContractorAdministrationModule), canActivate: featureGuards },
            { path: 'management', loadChildren: () => import('./modules/management/management.module').then(m => m.ManagementModule), canActivate: featureGuards },
            { path: 'profile', loadChildren: () => import('./modules/profile/profile.module').then(m => m.ProfileModule), canActivate: featureGuards },
            {
                path: '',
                component: HomeComponent,
                canActivate: [MsalGuard]
            },
            {
                path: 'login-failed',
                component: FailedComponent
            },
            {
                path: 'invoice-demo',
                component: InvoiceDemoComponent,
                canActivate: featureGuards
            },
        ]
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled'
    })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
